import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import IdentificacaoPrefeitura from './components/IdentificacaoPrefeitura';
import Loading from '../../../components/Loading/Loading';
//Api
import prefeitura_api from '../../../api/prefeitura_api';
//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Estado inicial da prefeitura
function initialStatePrefeitura() {
    return {
        fantasia: "",
        cidade: "",
        logotipo: null,
        status: "Ativo",
        quemCadastraGeradores: "Secretaria/Transportador",
        imprimi2ViaTicketColeta: false,
        obrigatorioFotoNaoColeta: false,
        tbUsuarios_Id: null,
        logotipoSecretaria: null,
        logotipoQRCode: null,
        logotipoBranco: null,
        logotipoSecretariaBranco: null,
        identificacaoDocumentoColeta: "",
        descricaoDocumentoColeta: "",
        analisePGRS: "false",
        quemCadastraContrato: "Transportador"
    }
}

export default function NovaPrefeitura({ id, loading, setLoading, btnVoltar }) {
    //Estado que guarda os dados da prefeitura a ser Adicionada/Editada
    const [prefeitura, setPrefeitura] = useState(initialStatePrefeitura);
    
    //Estado que guarda os erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do cadastro
    const campos = [
        objCampo({ name: "fantasia", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "identificacaoDocumentoColeta", required: true }),
    ]

    //Carrega os dados da prefeitura a ser editada se existir id
    useEffect(() => {
        if (id) {
            setLoading(true);
            prefeitura_api.GetItem(id).then(response => {
                setPrefeitura(response.data);
                setLoading(false);
            })
        }
    }, []);

    //Cadastra/Edita a prefeitura
    const onSubmit = () => {
        const erros = validarCampos(prefeitura, campos);
        setErrors(erros[0]);
        if (erros[1].length > 0) {
            return;
        }

        const _prefeitura = { ...prefeitura, imprimi2ViaTicketColeta: prefeitura.imprimi2ViaTicketColeta == "true" || prefeitura.imprimi2ViaTicketColeta == true, obrigatorioFotoNaoColeta: prefeitura.obrigatorioFotoNaoColeta == "true" || prefeitura.obrigatorioFotoNaoColeta == true }
       
        setLoading(true);
        if (prefeitura.id) {
            prefeitura_api.Update(_prefeitura).then(response => {
                setPrefeitura(initialStatePrefeitura);
                showMessage("Sucesso", "Prefeitura atualizada com sucesso", "success", btnVoltar);
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
                setLoading(false);
            })
        } else {
            prefeitura_api.Insert(_prefeitura).then(response => {
                showMessage("Sucesso", "Prefeitura adicionada com sucesso", "success", btnVoltar);
                setPrefeitura(initialStatePrefeitura);
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
                setLoading(false);
            })
        }
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard btnVoltar={btnVoltar}>
                {prefeitura != null &&
                    <>
                        <IdentificacaoPrefeitura prefeitura={prefeitura} setPrefeitura={setPrefeitura} errors={errors} setErrors={setErrors} campos={campos} />
                        <div className='mt-4 d-flex align-items-center justify-content-center'>
                            <Button className='bg-gradient' color={id ? 'warning text-light' : 'success'} onClick={onSubmit}>{id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : <>+ Adicionar</>}</Button>
                        </div>
                    </>
                }
            </MainCard>
        </>
    )
}